import React, { useEffect, useState } from "react";
import AcademyHead from "./AcademyHead";
import { useParams } from "react-router-dom";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import Spinner from "../../components/spinner/Spinner";
import { parseStatics } from "../../function/parseStatics";

interface IBlog {
  id?: string;
  title: string;
  firstText: string;
  secondText: string;
  thirdText: string;
  blogType: number;
  images: any;
}

const AcademyBlogDetail: React.FC = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState<IBlog[]>();
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);


  // GET A BLOG
  useEffect(() => {
    const getSingleBlog = async () => {
      setLoading(true);
      const response = await getFetcher(
        endpoints.eAcademy.getSingleBlog.replace("{blogId}", id || "")
      );

      if (response.result) {
        setBlog(response.blog.map((blog: any) => blog));
        setTimeout(() => {
          setLoading(false);
        }, 200);
      }
    };
    getSingleBlog();
  }, [id]);

  // CLICK IMAGE
  const handleClickImage = (url: string) => {
    setSelectedImage(url);
    setShowImageModal(true);
  }

  // SPINNER
  if(loading) return <div><Spinner /></div>


  return (
    <div className="flex flex-col min-h-screen">
      <div>
        <AcademyHead title={"ECZA AKADEMİ BLOG DETAY"} />
      </div>
      {blog?.map((item: IBlog, i: number) => {
        return (
          <div key={i} className="container mx-auto px-4 py-8">
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <div className="relative w-full h-64 sm:h-96 bg-gray-200">
                <img
                  src={parseStatics(item.images)[0]}
                  alt={item.title}
                  className="object-contain w-full h-full"
                />
              </div>

              <div className="p-6">
                <h1 className="text-3xl font-bold text-gray-800 mb-4">
                  {item.title}
                </h1>
                <div className="space-y-6">
                  <p className="text-gray-700 leading-relaxed">
                    {item.firstText}
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    {item.secondText}
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    {item.thirdText}
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                  {parseStatics(item.images).map(
                    (imageUrl: string, index: number) => (
                      <div key={index} className="w-full h-48" onClick={() => handleClickImage(imageUrl)}>
                        <img
                          src={imageUrl}
                          alt={`Additional Image ${index + 1}`}
                          className="object-cover w-full h-full rounded-lg shadow"
                        />
                      </div>
                    )
                  )}
                </div>
              </div>  
            </div>
          </div>
        );
      })}

      {/* IMAGE MODAL */}
      {showImageModal && (
        <div onClick={() => setShowImageModal(false)} className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
          <div className="w-full h-full absolute" onClick={() => setShowImageModal(false)}></div>

          <div className="relative w-full max-w-3xl h-1/2" onClick={(e) => e.stopPropagation()}>
              <img className="w-full h-full rounded-lg object-contain" src={selectedImage && selectedImage} alt="Full-size Image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AcademyBlogDetail;
